import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {OverlayType2} from "../../services/overlay/OverlayType2";

@Component({
  selector: 'app-overlay-type2-tab-item',
  templateUrl: './overlay-type2-tab-item.component.html',
  styleUrls: ['./overlay-type2-tab-item.component.scss']
})
export class OverlayType2TabItemComponent implements OnInit {

  @Input() item: OverlayType2;
  private isVisible = false;
  private isLoading = false;
  get visibility(){
    return this.isVisible;
  }

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.item.isVisible = false;
    this.item.hide();
    this.item.isLoading.subscribe(isLoading => {
      this.isLoading = isLoading;
      this.cd.detectChanges();
    })
  }

  toggleItemVisibility(){
    this.isVisible = !this.isVisible;
    this.item.isVisible = this.isVisible;
    if(this.isVisible){
      this.item.show()
    }
    else{
      this.item.hide();
    }
    this.cd.detectChanges();
  }

}
